const Layout = ({ children }) => (
    <div className="flex mx-auto items-center justify-center h-screen">
      <div className="w-6/12">
          {children}
      </div>
    </div>
);

export default Layout;
